// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_CancelarOrcamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /orcamentos/cancelarOrcamento/{id}
 *
 * Action endpoint with no payload — the controller signals success via the
 * envelope's `success` flag and emits `dados: null`. The `null` PHP type
 * (PHP 8.2+) drains the legacy `mixed` declaration without losing the
 * `Dados = null` shape downstream in TypeScript.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_CancelarOrcamentoResponseDados = null;

export type Orcamentos_CancelarOrcamentoResponse = ApiResponse<Orcamentos_CancelarOrcamentoResponseDados>;

registerResponseContract('Orcamentos_CancelarOrcamentoResponse', {})
